import React from "react";
import { IoClose } from "react-icons/io5";
import { IoMdAdd } from "react-icons/io";
import "./tablist.css";

function Tablist({ currentActive, setActive, domains, colors, addDomain, removeDomain }) {
	const handleDelete = (e, index) => {
		e.stopPropagation();
		if (currentActive === index || currentActive === domains.length - 1) {
			setActive(currentActive - 1);
		}
		removeDomain(index);
	}

	const handleAdd = () => {
		setActive(domains.length);
		addDomain();
	}

	return (
		<div className="tablist">
			{domains.map((_, index) => {
				return (
					<div
						key={index}
						id={index}
						className={index === currentActive ? "tab-container active" : "tab-container"}
						onClick={() => setActive(index)}
					>
						<div className="tab-title">
							<div
								className={"domain-color-indicator"}
								style={{ backgroundColor: index <= colors.length - 1 ? colors[index] : colors[index - colors.length] }}
							/>
							<p>Domain {index + 1}</p>
						</div>
						{index !== 0 ?
							<IoClose className="close-icon" size={20} onClick={(event) => handleDelete(event, index)} /> :
							<div className="spacer" />
						}


					</div>
				)
			})}
			{domains.length < 6 &&
				<IoMdAdd size={24} onClick={handleAdd} />
			}
		</div>)
}

export default Tablist;
